import { motion } from "framer-motion";
import { Bell, Brain, Shield } from "lucide-react";

const platformBenefits = [
  {
    icon: <Bell className="w-6 h-6 text-blue-600" />,
    title: "Smart Monitoring",
    description: "Real-time tracking of symptoms, medication adherence, and recovery milestones"
  },
  {
    icon: <Brain className="w-6 h-6 text-blue-600" />,
    title: "Cognitive Support",
    description: "AI-powered cognitive assessment and support throughout recovery"
  },
  {
    icon: <Shield className="w-6 h-6 text-blue-600" />,
    title: "Proactive Care",
    description: "Early detection and prevention of potential complications"
  }
];

export const PlatformBenefitsSection = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-8">Platform Benefits</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive support for patients and providers
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {platformBenefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white p-8 rounded-2xl shadow-lg"
            >
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                {benefit.icon}
              </div>
              <h3 className="text-2xl font-bold mb-4">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};